// src/types/filter.ts
var PriceType = {
  SALES_PRICE: "salesPrice",
  RENT_ANY: "rentAny",
  RENT_TOTAL: "rentTotal",
  RENT_NET: "rentNet",
  RENT_NET_PER_SQUARE_METER: "rentNetPerSquareMeter"
};
var FeaturesFilter = {
  hasAirConditioning: "hasAirConditioning",
  hasBalcony: "hasBalcony",
  hasBasement: "hasBasement",
  hasBuiltInKitchen: "hasBuiltInKitchen",
  hasElevator: "hasElevator",
  hasGarage: "hasGarage",
  hasGarden: "hasGarden",
  hasPatio: "hasPatio",
  hasSeaOrLakeView: "hasSeaOrLakeView",
  hasSecuritySystem: "hasSecuritySystem",
  hasSwimmingPool: "hasSwimmingPool",
  hasTennisCourt: "hasTennisCourt",
  hasTerrace: "hasTerrace",
  hasWaterfront: "hasWaterfront",
  hasHelipad: "hasHelipad",
  hasDoorman: "hasDoorman",
  hasPriceUpdated: "hasPriceUpdated"
};
var MultimediaFilter = {
  hasFloorplan: "hasFloorplan",
  hasVtourNormalized: "hasVtourNormalized",
  hasVideoNormalized: "hasVideoNormalized"
};

export {
  PriceType,
  FeaturesFilter,
  MultimediaFilter
};
